import AdminEmployees from '../admin/Employees';
export default AdminEmployees;
